<p-dialog [baseZIndex]="2000" [style]="{ maxWidth: '600px', marginTop: '30px' }" [(visible)]="modalVisible"
  [closable]="false" [closeOnEscape]="false" [dismissableMask]="false" [modal]="true" [position]="'center'"
  [draggable]="false">
  <div class="pr-3 pl-3">
    <div class="modal-header">
      <h4 class="modal-title">Switch Company</h4>
      <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="list-group">
        <div *ngFor="let company of companies; let i = index" class="list-group-item cursor-pointer"
          [class.active]="isSelected(company)" (click)="selectCompany(company)">
          {{ company.name }}
        </div>
      </div>
      <!-- Debug information -->
      <div *ngIf="companies.length === 0" class="alert alert-info">
        No companies available
      </div>
    </div>
  </div>
  <p-footer>
    <div class="w-100 text-right pr-3 pl-3 pb-3">
      <button type="button" class="btn btn-secondary mr-2" (click)="closeModal()">Cancel</button>
      <button type="button" class="btn btn-primary" [disabled]="!selectedCompany"
        (click)="showConfirmation()">Select</button>
    </div>
  </p-footer>
</p-dialog>

<!-- Confirmation Dialog -->
<p-dialog [(visible)]="confirmationVisible" [style]="{width: '600px'}" [modal]="true" 
  [draggable]="false" [resizable]="false" [baseZIndex]="2000">
  <p-header>
    <h4>Confirm Company Switch</h4>
  </p-header>
  <div class="confirmation-content">
    <i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: #ff9900;"></i>
    <span style="margin-left: 10px;">
      Are you sure you want to switch to <strong>{{ selectedCompany?.name }}</strong>?
    </span>
  </div>
  <p-footer>
    <button type="button" pButton (click)="cancelConfirmation()" label="No" class="p-button-secondary"></button>
    <button type="button" pButton (click)="proceedWithSelection()" label="Yes" class="p-button-primary"></button>
  </p-footer>
</p-dialog>